module.exports = __webpack_public_path__ + "static/media/logo-prit-new-black.db4fb6b5.png";